import { settingsActions } from '@redux/slices/settings';
import { getAppDispatch } from '@utilities/dispatch.util';

const companySupportManipulationJson = ({ data }) => {
  const companySupportText = data?.value || '';

  return {
    companySupportText
  };
};

const companySupportDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(settingsActions.setCompanySupportText(data?.companySupportText));
};

export { companySupportManipulationJson, companySupportDispatcher };
